import { render, staticRenderFns } from "./SectionHead.vue?vue&type=template&id=3c7488fd&lang=pug&"
import script from "./SectionHead.vue?vue&type=script&lang=js&"
export * from "./SectionHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports